import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onMounted, inject } from "vue";
import AccountService from "../services/AccountService";
import { useRoute } from "vue-router";
import levelRebateForm from "./form/LevelRebateForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRebateLevel',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(true);

const accountDetails = ref({});
const rebateType = ref("");
const route = useRoute();

const updateRebateRuleDetailId = (_id: any) => {
  accountDetails.value.rebateClientRule.rebateDirectSchemaId = _id;
};

onMounted(async () => {
  accountDetails.value = props.accountDetails;

  rebateType.value =
    props.accountDetails.rebateClientRule.distributionType.toString();

  if (route.query.accountId) {
    accountDetails.value = await AccountService.getAccountDetailById(
      parseInt(route.query.accountId as string)
    );
  }

  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createBlock(levelRebateForm, {
        key: 0,
        rebateType: rebateType.value,
        accountDetails: accountDetails.value,
        fromRebateRuleDetailId: 
      accountDetails.value.rebateClientRule.rebateDirectSchemaId
    ,
        onUpdateRebateRuleDetailId: updateRebateRuleDetailId
      }, null, 8, ["rebateType", "accountDetails", "fromRebateRuleDetailId"]))
    : _createCommentVNode("", true)
}
}

})